<div [@.disabled]="disableAnimation()">
    <div [@slideInOut]="active ? 'show' : 'hide'" class="legend-animate-container">

        <mat-accordion multi="false">

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RoadNetwork"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src='./assets/legend/Img50k/leg1_50k_{{translateService.currentLang.slice(0, -1)}}.png'
                        alt='{{"legend.RoadNetwork"|translate}}' width="230" height="1030">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RailNetwork"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img50k/leg2_50k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.RailNetwork"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.LandUse"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img50k/leg3_50k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.LandUse"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.Hydrography"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img50k/leg4_50k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.Hydrography"|translate}}' />
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.AdministrativeData"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img50k/leg5_50k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.AdministrativeData"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.Abbreviations"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img50k/leg6_50k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.Abbreviations"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.FieldPresentations"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img50k/leg7_50k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.FieldPresentations"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel is-open="group[8].isOpen">
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.BuildingsAndStructures"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img50k/leg8_50k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.BuildingsAndStructures"|translate}}'>
                </div>
            </mat-expansion-panel>

        </mat-accordion>
    </div>
</div>